<template src="./ReclamoDetailForm.html"></template>
<style lang="scss" src="./ReclamoDetailForm.scss"></style>

<script>
import {Button, DatePicker, Divider, Input, Option, Select, Switch} from 'element-ui'
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi"
import {requesServelMixin} from "src/api/servelApi"
import {requestAfiliacionPPMixin} from "@/api/partidoPolitico/afiliacionPPApi";
import {requestReclamosMixin} from "src/api/reclamosApi"
import {mapState} from "vuex"
import ScreenSizeMixin from "src/mixins/ScreenSizeMixin";
import {NotifyMixin} from "src/mixins/NotifyMixin";
import {RouterMixin} from "@/mixins/routerMixin";

export default {
  name: "ReclamoDetailForm",
  mixins: [
    requestAfiliacionMixin,
    requesServelMixin,
    requestAfiliacionPPMixin,
    requestReclamosMixin,
    ScreenSizeMixin,
    NotifyMixin,
    RouterMixin
  ],
  components: {
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Input.name]: Input,
    [Switch.name]: Switch,
    [Divider.name]: Divider,
  },
  props: {
    ciudadano: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
  },
  data() {
    const validateAcepta = (rule, value, callback) => {
      this.$log.debug('validateAcepta')
      if (value === '' || value === false) {
        callback(new Error('Debe aceptar la Declaración'));
      } else {
        callback();
      }
    };

    return {
      loading: true,
      errored: false,
      isAceptaValido: true,
      loadingRegiones: true,
      loadingComunas: true,
      isValidStreet: true,
      mensaje: '',
      model: {
        problema: '',
        listaProblemas: [],
        descripcionReclamo: '',
        acepta: false,
      },
      rules: {
        problema: [
          {
            required: true,
            message: 'Debe seleccionar un tipos de problema el cual es obligatorio',
            trigger: 'blur'
          }
        ],
        descripcionReclamo: [
          {
            required: true,
            message: 'Debe detallar el motivo de su reclamo el cual es obligatorio',
            trigger: 'blur'
          }
        ],
        acepta: [
          {
            required: true,
            message: 'Debe aceptar la Declaración',
            trigger: ['blur', 'change']
          },
          {
            validator: validateAcepta,
            trigger: ['blur', 'change']
          }
        ],
      },
    }
  },
  beforeMount() {
    this.listaProblemas()
  },
  methods: {
    goBack() {
      this.$emit('on-back')
    },
    listaProblemas() {
      this.errored = false

      this.listaProblemasReclamos()
        .then((res) => {
          if (res.data.statusCode === 200) {
            const registro = res.data.datos
            this.$log.debug('problemas... ', registro)
            this.model.listaProblemas = registro
          } else {
            this.showError(`No hay tipos de problemas reclamos.`)
            this.errored = true
          }
        })
        .catch(err => {
          this.showError('Ocurrió un error inesperado al cargar lista problemas reclamos')
          this.$log.debug('err', err)
          this.errored = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    validate() {
      this.$refs['reclamo-form'].validate((valid) => {
        if (valid) {
          this.$log.debug("enviando...")

          const loading = this.getLoading()

          const data = this.generarData()
          this.$log.debug('enviarSolicitud', data)

          return this.crearReclamo(data)
            .then(response => {

              this.$log.debug('respuesta', response)
              if (response.data.statusCode === 201) {
                this.showSuccess('Se genero con éxito su solicitud de reclamo')
                this.errorVer = false

                this.$emit('on-next-step')
              } else if (response.data.statusCode === 400) {
                this.showError('Error en los archivos.')
              } else {
                this.showError('Ocurrió un error inesperado al enviar la solicitud')
              }
              loading.close()
            })
            .catch(err => {
              this.$log.fatal('enviarSolicitud', err, err.response, err.request)

              loading.close()
              this.showError('Ocurrió un error inesperado al enviar la solicitud')
            })

        } else {
          this.$log.debug('error submit!!');
        }
      });
    },
    generarData() {
      let data = {}

      data.materno = this.ciudadano.materno
      data.nombres = this.ciudadano.nombres
      data.paterno = this.ciudadano.paterno

      data.domicilio = this.ciudadano.calle
      data.telefono = this.ciudadano.telefono
      data.codigoregion = this.ciudadano.region.cod_region
      data.region = this.ciudadano.region.nom_region
      data.codigocomuna = this.ciudadano.comuna.cod_comuna
      data.comuna = this.ciudadano.comuna.nom_comuna
      data.correo = this.ciudadano.email

      data.id_problema = this.model.problema
      data.reclamo = this.model.descripcionReclamo
      data.archivos = this.ciudadano.documentos

      return data
    }
  }
}

</script>
